// Team Icon Options for Fantasy Football Teams

export const TEAM_ICONS = {
  // Trophy & Achievement
  trophy: {
    name: "Trophy",
    emoji: "🏆",
    category: "achievement"
  },
  goldMedal: {
    name: "Gold Medal", 
    emoji: "🥇",
    category: "achievement"
  },
  crown: {
    name: "Crown",
    emoji: "👑",
    category: "achievement"
  },
  flexedBiceps: {
    name: "Flexed Biceps",
    emoji: "💪",
    category: "achievement"
  },
  shield: {
    name: "Shield",
    emoji: "🛡️",
    category: "achievement"
  },
  crossedSwords: {
    name: "Crossed Swords",
    emoji: "⚔️",
    category: "achievement"
  },

  // Football Icons
  football: {
    name: "Football",
    emoji: "🏈",
    category: "sports"
  },
  rugbyBall: {
    name: "Rugby Ball",
    emoji: "🏉", 
    category: "sports"
  },
  boxingGloves: {
    name: "Boxing Gloves",
    emoji: "🥊",
    category: "sports"
  },
  target: {
    name: "Target",
    emoji: "🎯",
    category: "sports"
  },
  bowAndArrow: {
    name: "Bow and Arrow",
    emoji: "🏹",
    category: "sports"
  },

  // Animal Mascots
  tiger: {
    name: "Tiger",
    emoji: "🐯",
    category: "animals"
  },
  lion: {
    name: "Lion",
    emoji: "🦁",
    category: "animals"
  },
  bear: {
    name: "Bear",
    emoji: "🐻",
    category: "animals"
  },
  wolf: {
    name: "Wolf",
    emoji: "🐺",
    category: "animals"
  },
  eagle: {
    name: "Eagle",
    emoji: "🦅",
    category: "animals"
  },
  crocodile: {
    name: "Crocodile",
    emoji: "🐊",
    category: "animals"
  },
  shark: {
    name: "Shark",
    emoji: "🦈",
    category: "animals"
  },
  elephant: {
    name: "Elephant",
    emoji: "🐘",
    category: "animals"
  },
  kangaroo: {
    name: "Kangaroo",
    emoji: "🦘",
    category: "animals"
  },
  koala: {
    name: "Koala",
    emoji: "🐨",
    category: "animals"
  },
  // NEW ANIMALS
  owl: {
    name: "Owl",
    emoji: "🦉",
    category: "animals"
  },
  dragon: {
    name: "Dragon",
    emoji: "🐉",
    category: "animals"
  },
  bull: {
    name: "Bull",
    emoji: "🐂",
    category: "animals"
  },
  dolphin: {
    name: "Dolphin",
    emoji: "🐬",
    category: "animals"
  },
  horse: {
    name: "Horse",
    emoji: "🐴",
    category: "animals"
  },
  fox: {
    name: "Fox",
    emoji: "🦊",
    category: "animals"
  },
  frog: {
    name: "Frog",
    emoji: "🐸",
    category: "animals"
  },
  turtle: {
    name: "Turtle",
    emoji: "🐢",
    category: "animals"
  },
  zebra: {
    name: "Zebra",
    emoji: "🦓",
    category: "animals"
  },
  penguin: {
    name: "Penguin",
    emoji: "🐧",
    category: "animals"
  },
  gorilla: {
    name: "Gorilla",
    emoji: "🦍",
    category: "animals"
  },
  otter: {
    name: "Otter",
    emoji: "🦦",
    category: "animals"
  },
  snake: {
    name: "Snake",
    emoji: "🐍",
    category: "animals"
  },
  boar: {
    name: "Boar",
    emoji: "🐗",
    category: "animals"
  },
  rhinoceros: {
    name: "Rhinoceros",
    emoji: "🦏",
    category: "animals"
  },
  camel: {
    name: "Camel",
    emoji: "🐪",
    category: "animals"
  },
  deer: {
    name: "Deer",
    emoji: "🦌",
    category: "animals"
  },
  leopard: {
    name: "Leopard",
    emoji: "🐆",
    category: "animals"
  },
  turkey: {
    name: "Turkey",
    emoji: "🦃",
    category: "animals"
  },
  rooster: {
    name: "Rooster",
    emoji: "🐓",
    category: "animals"
  },
  parrot: {
    name: "Parrot",
    emoji: "🦜",
    category: "animals"
  },
  bee: {
    name: "Bee",
    emoji: "🐝",
    category: "animals"
  },
  butterfly: {
    name: "Butterfly",
    emoji: "🦋",
    category: "animals"
  },
  lizard: {
    name: "Lizard",
    emoji: "🦎",
    category: "animals"
  },
  fish: {
    name: "Fish",
    emoji: "🐟",
    category: "animals"
  },
  shrimp: {
    name: "Shrimp",
    emoji: "🦐",
    category: "animals"
  },

  // Colored Stars
  star: {
    name: "Star",
    emoji: "⭐",
    category: "stars"
  },
  glowingStar: {
    name: "Glowing Star",
    emoji: "🌟",
    category: "stars"
  },
  sparkles: {
    name: "Sparkles",
    emoji: "✨",
    category: "stars"
  },

  // Colored Circles
  redCircle: {
    name: "Red Circle",
    emoji: "🔴",
    category: "circles"
  },
  blueCircle: {
    name: "Blue Circle", 
    emoji: "🔵",
    category: "circles"
  },
  greenCircle: {
    name: "Green Circle",
    emoji: "🟢", 
    category: "circles"
  },
  yellowCircle: {
    name: "Yellow Circle",
    emoji: "🟡",
    category: "circles"
  },
  purpleCircle: {
    name: "Purple Circle",
    emoji: "🟣",
    category: "circles"
  },
  orangeCircle: {
    name: "Orange Circle",
    emoji: "🟠",
    category: "circles"
  },
  blackCircle: {
    name: "Black Circle",
    emoji: "⚫",
    category: "circles"
  },
  whiteCircle: {
    name: "White Circle",
    emoji: "⚪",
    category: "circles"
  },
  // Objects & Weather
  stadium: {
    name: "Stadium",
    emoji: "🏟️",
    category: "objects"
  },
  tornado: {
    name: "Tornado",
    emoji: "🌪️",
    category: "weather"
  },
  lightning: {
    name: "Lightning",
    emoji: "⚡",
    category: "weather"
  },
  fire: {
    name: "Fire",
    emoji: "🔥",
    category: "weather"
  },
  wave: {
    name: "Wave",
    emoji: "🌊",
    category: "weather"
  },
  volcano: {
    name: "Volcano",
    emoji: "🌋",
    category: "weather"
  },
  snowflake: {
    name: "Snowflake",
    emoji: "❄️",
    category: "weather"
  },
  cloudWithLightning: {
    name: "Cloud with Lightning",
    emoji: "🌩️",
    category: "weather"
  },
  sun: {
    name: "Sun",
    emoji: "☀️",
    category: "weather"
  },
  moon: {
    name: "Moon",
    emoji: "🌙",
    category: "weather"
  },
  diamond: {
    name: "Diamond",
    emoji: "💎",
    category: "objects"
  },
  robot: {
    name: "Robot",
    emoji: "🤖",
    category: "objects"
  },
  alien: {
    name: "Alien",
    emoji: "👽",
    category: "objects"
  },
  skull: {
    name: "Skull",
    emoji: "💀",
    category: "objects"
  }
};

// Get all icons as an array
export const getAllTeamIcons = () => {
  return Object.entries(TEAM_ICONS).map(([key, icon]) => ({
    key,
    ...icon
  }));
};

// Get icons by category
export const getIconsByCategory = (category) => {
  return getAllTeamIcons().filter(icon => icon.category === category);
};

// Get default icon
export const getDefaultIcon = () => {
  return TEAM_ICONS.football;
};

// Save team icon to API
export const saveTeamIcon = async (teamName, iconKey, leagueId, currentUser = null) => {
  try {
    const teamManagementApi = (await import('../services/teamManagementApi')).default;
    await teamManagementApi.saveTeamCustomization(leagueId, teamName, null, iconKey, currentUser);
  } catch (error) {
    console.error('Error saving team icon:', error);
  }
};

// Get team icon from API
export const getTeamIcon = async (teamName, leagueId, currentUser = null) => {
  try {
    const teamManagementApi = (await import('../services/teamManagementApi')).default;
    const customization = await teamManagementApi.getTeamCustomization(leagueId, teamName, currentUser);
    const iconKey = customization?.icon_key;
    return iconKey && TEAM_ICONS[iconKey] ? TEAM_ICONS[iconKey] : getDefaultIcon();
  } catch (error) {
    console.error('Error getting team icon:', error);
    return getDefaultIcon();
  }
}; 